import React from 'react';

export default function PhotoRow({ before_images, after_images }) {
  return (
    <>
      <div className='d-flex'>
       {before_images.map(p => (
          <div style={{width: "fit-content"}} className='mx-1'>
            <img id={p} src={p} style={{ maxHeight: 120 }} className='rounded' />
            <p className='text-center text-white bg-dark rounded'>Before</p>
          </div>
        ))}
        {after_images.map(p => (
          <div style={{width: "fit-content"}} className='mx-1'>
            <img id={p} src={p} style={{ maxHeight: 120 }} className='rounded' />
            <p className='text-center text-white bg-dark rounded'>After</p>
          </div>
        ))}
      </div>
    </>
  )
}